import { orderedBreakpoints } from '../../utils/responsive.es.js';

const getItemsPerPage = (rules, breakpointsState) => {
  const currentKey = orderedBreakpoints.find((key) => breakpointsState[key] && rules[key]);
  return rules[currentKey ? currentKey : "default"];
};

export { getItemsPerPage };
//# sourceMappingURL=helpers.es.js.map
